import { j as a } from "../../jsx-runtime.BREq8dyb.js";
import { styled as c, AccordionDetails as n, useThemeProps as i } from "@mui/joy";
import { forwardRef as l } from "react";
const o = "DqSortableAccordionDetails", p = c(n, {
  name: o,
  slot: "root"
})({
  backgroundColor: "var(--joy-palette-background-surface)"
}), u = l((r, t) => {
  const {
    children: e,
    ...s
  } = i({
    name: o,
    props: r
  });
  return /* @__PURE__ */ a.jsx(p, { ref: t, ...s, children: e });
});
export {
  u as default
};
//# sourceMappingURL=DqSortableAccordionDetails.js.map
